import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

const CustomSwitch = styled(Switch)(({ theme }) => {
  const trackWidth = 60;
  const trackHeight = 28;
  const thumbSize = 24;
  const padding = 2;
  const onTranslate = trackWidth - thumbSize - padding * 2; // 52 - 24 - 4 = 24

  return {
    width: trackWidth,
    height: trackHeight,
    padding: 0,
    display: 'inline-flex',
    '& .MuiSwitch-switchBase': {
      padding,
      transform: 'translateX(0)', // OFF: サムは左端
      transition: theme.transitions.create(['transform'], {
        duration: theme.transitions.duration.shortest,
      }),
      '&.Mui-checked': {
        transform: `translateX(${onTranslate}px)`, // ON: サムは右端
        '& + .MuiSwitch-track': {
          backgroundColor: theme.palette.success.main,
          opacity: 1,
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: thumbSize,
      height: thumbSize,
      backgroundColor: theme.palette.common.white,
      boxShadow: theme.shadows[1],
    },
    '& .MuiSwitch-track': {
      borderRadius: trackHeight / 2,
      backgroundColor: theme.palette.mode === 'dark' ? '#475569' : theme.palette.grey[400],
      opacity: 1,
      position: 'relative',
      // OFF時のラベル
      '&:before': {
        content: '"オフ"',
        position: 'absolute',
        top: '50%',
        left: padding * 14 + 'px',   // 4px 内側
        transform: 'translateY(-50%)',
        color: theme.palette.common.white,
        fontSize: '0.75rem',
        fontWeight: 500,
      },
    },
    // ON時のラベルに切り替え
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track:before': {
      content: '"オン"',
      left: 'auto',
      right: padding * 14 + 'px',  // 右側に4px内側
    },
  };
});

export default CustomSwitch;
